import { createRoot } from "react-dom/client";
import "./styles.css";
// import { Logo } from '@pmndrs/branding'
import { App } from "./App";

/*
Model JSX auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.3 model.glb --transform --simplify --resolution=2048
Author: Omar Faruq Tawsif (https://sketchfab.com/omarfaruqtawsif32)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
*/

/* 
Adapted by: Rico Washington / Dan Black
Date: 3/14/2025
*/

function Root() {
  return (
    <>
      <App />
      <div
        style={{
          position: "absolute",
          pointerEvents: "none",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
        }}
      >
        <a
          href="/contact"
          style={{
            position: "absolute",
            bottom: 40,
            left: 40,
            fontSize: "13px",
            fontFamily: "sans-serif",
            textDecoration: "underline",
          }}
          className="index-link"
        >
          Contact
        </a>
        <div
          style={{
            position: "absolute",
            bottom: 40,
            right: 40,
            fontSize: "13px",
            fontFamily: "sans-serif",
          }}
          className="index-text"
        >
          &copy; Rico Washington 2025
        </div>
        {/* <Logo style={{ position: 'absolute', bottom: 40, left: 40, width: 30 }} /> */}
        <a
          style={{ position: "absolute", top: 40, left: 40, fontSize: "28px" }}
          href="#"
        >
          Your Granda Is Funky.
        </a>
      </div>{" "}
    </>
  );
}

createRoot(document.getElementById("root")).render(<Root />);
